import { render, staticRenderFns } from "./FollowUpOrderTypes.vue?vue&type=template&id=24c50a8d&"
import script from "./FollowUpOrderTypes.vue?vue&type=script&lang=js&"
export * from "./FollowUpOrderTypes.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpOrderTypes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports